const society = {
    name: '',
    email: '',
    phone: ''
};

export default society
